"use client";
import { useCallback, useEffect, useState } from "react";

const LISTENERS = [
  "click",
  "mousedown",
  "focus",
  "blur",
  "mousemove",
  "mousewheel",
  "keydown",
  "touchstart",
  "touchmove",
  "resize",
  "scroll",
  "zoom",
] as any[];

const INTERVAL = 5 * 60 * 1000;

let timer: ReturnType<typeof setTimeout>;

export const useIdleTime = () => {
  const [timePassed, setTimePassed] = useState(false);

  const resetTime = () => {
    setTimePassed(false);

    LISTENERS.forEach((listener) => {
      document.body.addEventListener(listener, resetTimer);
    });

    timer = setTimeout(() => {
      setTimePassed(true);
    }, INTERVAL);
  };

  const resetTimer = useCallback(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setTimePassed(true);
      LISTENERS.forEach((listener) => {
        document.body.removeEventListener(listener, resetTimer);
      });
    }, INTERVAL);
  }, []);

  useEffect(() => {
    timer = setTimeout(() => {
      setTimePassed(true);
      LISTENERS.forEach((listener) => {
        document.body.removeEventListener(listener, resetTimer);
      });
    }, INTERVAL);

    LISTENERS.forEach((listener) => {
      document.body.addEventListener(listener, resetTimer);
    });

    return () => {
      clearTimeout(timer);
      LISTENERS.forEach((listener) => {
        document.body.removeEventListener(listener, resetTimer);
      });
    };
  }, [resetTimer]);

  return { timePassed, resetTime };
};
